var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.8,
    stroke: "#B5B5B5",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7178 20.1616H16.2794C16.5098 20.1616 16.7317 20.1445 16.945 20.1104C17.1583 20.0763 17.3461 20.0123 17.5082 19.9184C17.6703 19.816 17.7983 19.6752 17.8922 19.496C17.9946 19.3168 18.0458 19.0821 18.0458 18.792C18.0458 18.5019 17.9946 18.2672 17.8922 18.088C17.7983 17.9088 17.6703 17.7723 17.5082 17.6784C17.3461 17.576 17.1583 17.5077 16.945 17.4736C16.7317 17.4395 16.5098 17.4224 16.2794 17.4224H14.7178V20.1616ZM12.7082 15.8608H16.8298C17.4015 15.8608 17.8879 15.9461 18.289 16.1168C18.6901 16.2789 19.0143 16.4965 19.2618 16.7696C19.5178 17.0427 19.7013 17.3541 19.8122 17.704C19.9317 18.0539 19.9914 18.4165 19.9914 18.792C19.9914 19.1589 19.9317 19.5216 19.8122 19.88C19.7013 20.2299 19.5178 20.5413 19.2618 20.8144C19.0143 21.0875 18.6901 21.3093 18.289 21.48C17.8879 21.6421 17.4015 21.7232 16.8298 21.7232H14.7178V25H12.7082V15.8608ZM22.5997 21.4672H24.9677L23.8157 18.1136H23.7901L22.5997 21.4672ZM22.7917 15.8608H24.8525L28.2701 25H26.1837L25.4925 22.9648H22.0749L21.3581 25H19.3357L22.7917 15.8608Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPa);
export default __webpack_public_path__ + "static/media/icon-pa.be4e1e9a196c0aa8d4cea1b07f7c4b2d.svg";
export { ForwardRef as ReactComponent };